/** Locale-formatted currency amounts (e.g. 4,250). */
export function formatCurrencyAmount(value: number | string | null | undefined) {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '0';
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(
    Math.round(n),
  );
}
